import { ArrowRightIcon } from '@grupoboticario/flora-react-icons';
import {
  Container,
  Title,
  SidebarWrapper,
  Sidebar,
  SidebarTitle,
} from './styles';

export interface Filters {
  options: any;
  selectedPeriodRecent: string;
  handlePeriodRecent: (id: string) => void;
}
export const FilterReports = ({
  options,
  selectedPeriodRecent,
  handlePeriodRecent,
}: Filters) => {
  return (
    <Container>
      <Title>Tipos de relatórios</Title>
      <SidebarWrapper>
        <SidebarTitle>Relatórios por tipo</SidebarTitle>
        <Sidebar>
          <ul>
            {options.map(option => (
              <li
                aria-hidden="true"
                key={option}
                onClick={() => handlePeriodRecent(option)}
                className={selectedPeriodRecent === option ? 'selected' : ''}
              >
                <div className="content">
                  {option}
                  <ArrowRightIcon />
                </div>
              </li>
            ))}
          </ul>
        </Sidebar>
      </SidebarWrapper>
    </Container>
  );
};
